import { render, staticRenderFns } from "./AppFormLegacy.vue?vue&type=template&id=cfaf4dec&scoped=true"
import script from "./AppFormLegacy.vue?vue&type=script&lang=js"
export * from "./AppFormLegacy.vue?vue&type=script&lang=js"
import style0 from "./AppFormLegacy.vue?vue&type=style&index=0&id=cfaf4dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaf4dec",
  null
  
)

export default component.exports